import React, { useEffect } from "react";
import { getNotificationEmailAction } from "../../../state/usecase/user/actions";
import { useAppDispatch } from "../../../state/store";
import { useSendLocationToGtag } from "../../hooks/common/useSendLocationToGtag";
import { EmailList } from "./components/EmailList";
import { NotificationEmailProvider } from "../../provider/NotificationEmailProvider";
import { SaveButtonArea } from "./components/SaveButtonArea";

export function NotificationEmailPage() {
    const dispatch = useAppDispatch();

    useSendLocationToGtag("通知先設定");

    useEffect(() => {
        dispatch(getNotificationEmailAction());
    }, [dispatch]);

    return (
        <NotificationEmailProvider>
            <div className={"notification_email_page"}>
                <div className={"container"}>
                    <h1 className={"page_title"}>通知先設定</h1>
                    <EmailList />
                    <SaveButtonArea />
                </div>
            </div>
        </NotificationEmailProvider>
    );
}
